// extracted by mini-css-extract-plugin
module.exports = {"container":"_3lTfxPSnbn7NTLf8f1-q19","title":"_1izPtDpwhevoYP1NX4qbMz","header":"_1UuC8uvfoDHXRgSsJ_k5FP","content":"pDZiWLRHGGOjTuxFFjqWb","subTitle":"sFYs6sJZ032xW16ntlBuI"};